import Service from "../service";

const courses = {
  onGetCourses() {
    return Service.get("/courses");
  },
};

export default courses;
